import { render, staticRenderFns } from "./CertificadosBasePantalla.vue?vue&type=template&id=f81a35f6&"
import script from "./CertificadosBasePantalla.vue?vue&type=script&lang=ts&"
export * from "./CertificadosBasePantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports